module.exports = __webpack_public_path__ + "img/laspi.6523ea0b.jpg";